import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {SubscriptionItem} from "../types.ts";
import {CreatedByProfileFormatter} from "../../../components/CreatedByProfileFormatter.tsx";


export const Profile = ({record}: { record: SubscriptionItem }) => {


    const properties = [
        {
            label: 'Price',
            value: record.price ? record.price.amount : record.priceId,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Quantity',
            value: record.quantity,
            span: 12,
        }, {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: rbacActions.UpdateSubscriptionItem,
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }] as PlatformPropertyCardProperty[];


    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (
        <PlatformPropertyCard properties={allowedProperties}/>
    );


};
